export default __webpack_public_path__ + "static/tech-2-59988fde04ccb1cb558dc9e435a4ff73.jpg";